<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="dialogModal" tabindex="-1" role="dialog" >
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        {{dialogConfig.msgTitle}}
                    </div>

                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="field">
                                    <div class="field-name">{{dialogConfig.msgHeader}}</div>
                                    <div>{{dialogConfig.msgText}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-gray" data-dismiss="modal">{{$t('Buttons.Cancel')}}</button>
                        <button type="button" class="btn btn-danger" data-dismiss="modal">{{$t('Buttons.Ok')}}</button>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>
<script>
import { mapGetters  } from 'vuex';
export default {
  name: 'BaseFullModal',
  data() {
    return {
        msgTitle: '訊息',
        msgHeader: '訊息',
        msgText: ''
    };
  },  
  mounted() {        
     this.msgTitle = this.dialogConfig.msgTitle;
     this.msgHeader  =  this.dialogConfig.msgHeader;
     this.msgText  =  this.dialogConfig.msgText;
  },
  computed: {
    ...mapGetters(['dialogConfig']),
  },
  methods: {
  },
};
</script>
<style lang="scss" scoped>
.btn-blue {
    color: #fff !important;
    font-size: .85em;
    background: #343b55;
}

.btn-gray {
    background-color: gray;
    color: white;
}

.modal-body .alert-box .alert-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: normal;
}

.modal-body {
    background-color: #ECEEF6;
}

.field-name {
    font-weight: bolder;
    color: #000;
}

</style>